const Situacao = {
  AFILIADO_INDICACAO: {
    PENDENTE: 239,
    CONFIRMADO: 240,
    RECUSADO: 241,
  },

  AFILIADO_INDICACAO_CUPOM: {
    DISPONIVEL: 242,
    RESGATADO_RENOVACAO: 243,
    RESGATADO_VALE: 244,
  },

  getString(id) {
    return (
      {
        // AFILIADO_INDICACAO
        239: 'Indicação Pendente',
        240: 'Indicação Confirmada',
        241: 'Indicação Recusada',

        // AFILIADO_INDICACAO_CUPOM
        242: 'Cupom Disponível',
        243: 'Cupom Resgatado na Renovação',
        244: 'Cupom Resgatado como Vale Presente',
      }[id] || ''
    );
  },
};

export default Situacao;
